<ion-content [fullscreen]="true">
  <ion-row>
    <ion-col>
      <p>
        Votre intervention <span class="txt-agil">{{nom}}</span> a été validée !
      </p>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <div class="button-container">
        <ion-img src="../../../../assets/img/illustration_menage_no_background.png"></ion-img>
        <ion-icon class="checkmarkcirclee" (click)="dismiss()" name="checkmark-circle"></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</ion-content>